var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"config-box"},[_c('PowerMainTable',{staticClass:"block-pos",attrs:{"mitem":_vm.mains}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }